import emailjs from 'emailjs-com';

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const USER_ID = process.env.REACT_APP_EMAILJS_USER_ID;
const TEMPLATE_ID = 'template_contato';

export async function send(
  sender: string,
  name: string,
  phone: string,
  message: string,
) {
  return emailjs.send(SERVICE_ID!, TEMPLATE_ID, {
    from_name: name,
    from_email: sender,
    from_phone: phone,
    message,
  }, USER_ID!);
}
